import React, { useEffect } from 'react'
import PmModuleStyle from '../styles/pm.module.css';
const ProjectedDays = ({simObj,costParameters,simulationRunning}) => {
    // let costParameters = []
    // let projectedCompletionTime = parseInt(costParameters?.length > 0 ?  costParameters[1]?.value : 0);
    // let projectedCompletionTime = simObj?.laststate?.projectedCompletionTime ?  simObj?.laststate?.projectedCompletionTime : 0;
    const progressbar = {
        valuemin: 100,
        valuemax: 175,
        valuenow: function () {
          let value = costParameters?.projectedCompletionTime ?  costParameters?.projectedCompletionTime : 0
          return Math.ceil(value- this.valuemin) / (this.valuemax - this.valuemin) * 100;
        },
      };
    return (
        <div className={`${PmModuleStyle["projected-days"]}`}>
          <div className={`${PmModuleStyle["projected-days-child"]}`}>
            <div>
                <div>
                    <h3 className={`${PmModuleStyle["pl-header"]}`}>Projected Days</h3>
                </div>
                <p className={`${PmModuleStyle['pl-amt']}`} ><strong>{costParameters?.projectedCompletionTime ?  costParameters?.projectedCompletionTime : 0}</strong></p>
                <p className={`${PmModuleStyle["fs-12"]}`}>{costParameters?.projectStatus ?  costParameters?.projectStatus + " " : ''}
                  {costParameters?.projectDelay ?  costParameters?.projectDelay + " " : ''}
                
                {/* {(simulationRunning && simObj?.deadlinedays - simObj?.laststate?.projectedCompletionTime != 0) && Math.abs(simObj?.deadlinedays - simObj?.laststate?.projectedCompletionTime)}
                {
                  simulationRunning ? ((simObj?.deadlinedays - simObj?.laststate?.projectedCompletionTime === 0) ? "On time" :
                  (simObj?.deadlinedays - simObj?.laststate?.projectedCompletionTime < 0) ? " days over time" : " days ahead of time") : ""
                } */}
                </p>
            </div>
            <div className={`${PmModuleStyle["quarter-progress"]}`}>
            <div className={`${PmModuleStyle.progress}`} role="progressbar"
              aria-valuenow={progressbar.valuenow()}
              aria-valuemin={progressbar.valuemin}
              aria-valuemax={progressbar.valuemax}
              aria-valuetext={`${progressbar.valuenow()}%`}>
              <div className={`background`} id={`${PmModuleStyle.profitLoss}`}>
                <div className={`${PmModuleStyle['progress-fg']}`} style={{ "width": progressbar.valuenow() + "%", backgroundColor: (costParameters?.projectedCompletionTime <= simObj?.deadlinedays ? '#008638' : '#B90000') }}></div>
              </div>
            </div>
          </div>
          <div className={`${PmModuleStyle["margin-line"]}`}>
            <div>100</div>
            <div>125</div>
            <div>150</div>
            <div>175</div>
           </div>
           </div>
        </div>
    )
}

export default ProjectedDays